define('modules/integrations/router',['require','exports','module','jquery','backbone','modules/private/index','modules/accounts/groups/index','modules/start/index','./view','./services/zapier/index','./services/shopify/index','./services/api/index','env'],function (require, exports, module) {
  "use strict";

  var $ = require("jquery"),
    Backbone = require("backbone"),
    Private = require("modules/private/index"),
    Groups = require("modules/accounts/groups/index"),
    Start = require("modules/start/index"),
    MainView = require("./view"),
    Zapier = require("./services/zapier/index"),
    Shopify = require("./services/shopify/index"),
    Api = require("./services/api/index"),
    Config = require("env");

  var TAB_CONTENT = "#integrations-tab-content";

  var init = function (activeTab, callback, showNotice) {
    Private.init(
      function (me) {
        var group = new Groups.Model(),
          products = new Start.Products();

        var mainViewData = {
          el: "#content",
          me: me,
          group: group,
          products: products,
          serviceToRender: callback,
          service: activeTab,
        };

        var mainView = new MainView(mainViewData);

        var productsFetch = function () {
          products.fetch({
            success: function () {
              mainView.render();
              callback(me, group);
            },
          });
        };

        group.fetch({ success: productsFetch });
      },
      null,
      showNotice
    );
  };

  module.exports = Backbone.Router.extend({
    initialize: function () {},
    saveCps: false,
    hasBeenCreatedEmblueAccount: false,
    routes: {
      "integrations(/)": "initZapier",
      "integrations/service/zapier": "initZapier",
      "integrations/service/shopify": "initShopify",
      "integrations/service/api": "initApi",
      "savenewcps/(:redirect)(/:query)": "saveNewCps",
      "createemblueaccount/(:redirect)(/:query)": "createEmblueAccount",
    },

    initZapier: function () {
      var self = this;
      init(
        "zapier",
        function (me, group) {
          var viewParams = {
            el: TAB_CONTENT,
            me: me,
            group: group,
          };
          var zapierView = new Zapier.View(viewParams);
          zapierView.render();
          self.afterRender();
        },
        true
      );
    },

    initShopify: function () {
      var self = this;
      init(
        "shopify",
        function (me, group) {
          var viewParams = {
            el: TAB_CONTENT,
            me: me,
            group: group,
            model: new Shopify.Model(),
          };

          new Shopify.View(viewParams).render();

          self.afterRender();
        },
        true
      );
    },

    initApi: function () {
      if (!Config.integrations.APIsEnabled) {
        location.href = Config.defaultDomain + "accounts/user/me";
      }

      var self = this;

      init(
        "api",
        function (me, group) {
          var viewParams = {
            el: TAB_CONTENT,
            me: me,
            group: group,
            model: new Api.Model(),
            collection: new Api.Collection(),
          };

          new Api.View(viewParams).render();
          self.afterRender();
        },
        true
      );
    },
    saveNewCps: function (redirect, query) {
      var self = this;
      //https://signup.dev.mdirector.com/savenewcps/aHR0cHM6Ly9zaWdudXAuZGV2Lm1kaXJlY3Rvci5jb20vYWNjb3VudHM/Y29tcGFueV9pZD00MzM0OQ==
      //TODO esto deberia de estar en otro router
      init(
        "saveNewCps",
        function (me, group) {
          console.log("init saveNewCps function, ", self.saveCps);
          !self.saveCps &&
            group.save(
              {
                agreementsName: "EmBlueCPS",
              },
              {
                success: function (model) {
                  var url = self.getUrlRedirect(redirect, query);
                  window.location = url;
                },
                error: function (model, response) {
                  console.log("error", response);
                },
              }
            );
          self.saveCps = true;
        },
        false
      );
    },
    getUrlRedirect: function (redirect, query) {
      var bytesDecodificados = Uint8Array.fromBase64(redirect);
      var textoOriginal = new TextDecoder().decode(bytesDecodificados);
      var queryOriginal = "";
      if (!query) {
        return textoOriginal;
      }

      bytesDecodificados = Uint8Array.fromBase64(query);
      var queryOriginal = new TextDecoder().decode(bytesDecodificados);
      return textoOriginal + "?" + queryOriginal;
    },
    createEmblueAccount: function (redirect, query) {
      var self = this;
      //https://signup.dev.mdirector.com/createemblueaccount/aHR0cHM6Ly9zaWdudXAuZGV2Lm1kaXJlY3Rvci5jb20vYWNjb3VudHM/Y29tcGFueV9pZD00MzM0OQ==
      //TODO esto deberia de estar en otro router
      init(
        "createEmblueAccount",
        function (me, group) {
          console.log(
            "init createEmblueAccount function, ",
            self.hasBeenCreatedEmblueAccount
          );
          // !self.hasBeenCreatedEmblueAccount;
          self.hasBeenCreatedEmblueAccount = true;
        },
        false
      );
    },

    afterRender: function () {
      $(".i18n").i18n();
    },
  });
});

